module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"plus":"view more","less":"view less"},"fr":{"plus":"voir plus","less":"voir moins"},"de":{"plus":"mehr sehen","less":"weniger sehen"}}')
  delete Component.options._Ctor
}
